import { createContext, FC, ReactElement, useState } from 'react'

import { SlideType } from '../_types'

export interface PresentationSettings {
  slides: SlideType[]
  pdfURL: string
  pptURL: string
  pptxURL: string
  activeSlideIndex: number
  isLoaded: boolean
  secretTest: string
  networkReturned?: boolean
  siteCode:string
}
export const initialPresentationSettings = {
  slides: [] as SlideType[],
  pdfURL: "",
  pptURL: "",
  pptxURL: "",
  activeSlideIndex: 0,
  isLoaded: false,
  secretTest: 'boo',
  networkReturned: false,
  siteCode: ""
} as PresentationSettings

export interface IPresentationContext {
  presentationSettings: PresentationSettings
  setPresentationSettings: React.Dispatch<
    React.SetStateAction<PresentationSettings>
  >
  slides: SlideType[]
  pdfURL: string
  pptURL: string
  pptxURL: string
  activeSlideIndex: number
  isLoaded: boolean
  networkReturned?: boolean
  siteCode: string
}
export const PresentationContext = createContext({
  setPresentationSettings: () => {},
  presentationSettings: {} as PresentationSettings,
  isLoaded: initialPresentationSettings.isLoaded,
  slides: initialPresentationSettings.slides,
  pdfURL: initialPresentationSettings.pdfURL,
  pptURL: initialPresentationSettings.pptURL,
  pptxURL: initialPresentationSettings.pptxURL,
  activeSlideIndex: initialPresentationSettings.activeSlideIndex,
  networkReturned: initialPresentationSettings.networkReturned,
  siteCode: initialPresentationSettings.siteCode
} as IPresentationContext)
export interface PresentationProviderProps {
  children: ReactElement | ReactElement[]
}
export const PresentationProvider: FC<PresentationProviderProps> = ({
  children,
}) => {
  const [presentationSettings, setPresentationSettings] =
    useState(initialPresentationSettings)
  const contextValues = {
    presentationSettings,
    setPresentationSettings,
    slides: presentationSettings.slides,
    pdfURL: presentationSettings.pdfURL,
    pptURL: presentationSettings.pptURL,
    pptxURL: presentationSettings.pptxURL,
    siteCode: presentationSettings.siteCode,
    activeSlideIndex: presentationSettings.activeSlideIndex,
    isLoaded: presentationSettings.isLoaded,
  }

  return (
    <PresentationContext.Provider value={contextValues}>
      {children}
    </PresentationContext.Provider>
  )
}

export default PresentationProvider
